//
//
//
//
//
//
import GlobalMenu from "@/components/page/GlobalMenu";
import store from '@/store';
export default {
  name: "MainMenu",
  components: {
    GlobalMenu: GlobalMenu
  },
  created: function created() {
    store.commit("SET_MENU_VISIBLE", true);
  }
};